import { CircularProgress } from '@mui/material';
import { Spinner } from 'react-bootstrap';

export default function Loading({ isToHidden }) {
  return (
    <div
      hidden={isToHidden}
      className="loading-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(var(--bs-body-bg-rgb), 0.6)',
        backdropFilter: 'blur(2px)',
        zIndex: 1400,
      }}
    >
      <CircularProgress />
    </div>
  );
}
